import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const PersistentTagIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper
      {...props}
      viewBox="0 0 132 132" // The viewbox here is important as it won't display properly without this specific value
    >
      <g
        transform="translate(0.000000,132.000000) scale(0.050000,-0.050000)"
        fill={props.fill ?? '#000000'}
        stroke="none"
      >
        <path
          d="M866 1674 c-201 -201 -366 -378 -366 -393 0 -55 584 -621 641 -621
89 0 151 84 109 148 -27 41 -33 87 -27 223 9 216 22 229 241 229 l156 0 0 79
c0 136 76 176 176 92 81 -69 84 -60 84 249 0 369 9 360 -371 360 l-278 0 -365
-366z m833 167 c58 -108 -34 -215 -130 -152 -69 45 -80 82 -41 141 41 63 140
69 171 11z"
        />
        <path
          d="M1714 1387 c-8 -7 -14 -57 -14 -110 l0 -97 -190 0 -190 0 0 -170 0
-170 190 0 190 0 0 -97 c0 -53 6 -103 14 -110 16 -16 386 345 386 377 0 32
-370 393 -386 377z"
        />
      </g>
    </SvgWrapper>
  );
};
